import { createContext, useContext, useState, useEffect } from "react";
import { API_BASE } from "../utils/api";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user,    setUser]    = useState(null);
  const [token,   setToken]   = useState(localStorage.getItem("token"));
  const [loading, setLoading] = useState(true);

  // Verify token on mount — if token is expired/invalid, log out
  useEffect(() => {
    const verify = async () => {
      const savedToken = localStorage.getItem("token");
      if (!savedToken) { setLoading(false); return; }

      try {
        const res = await fetch(`${API_BASE}/api/auth/me`, {
          headers: { Authorization: `Bearer ${savedToken}` },
        });
        if (res.ok) {
          const userData = await res.json();
          setUser(userData);
          setToken(savedToken);
          localStorage.setItem("user", JSON.stringify(userData));
        } else {
          // Token invalid or expired — clear everything
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          setToken(null);
          setUser(null);
        }
      } catch (_) {
        // Backend offline — use cached user if available
        const savedUser = localStorage.getItem("user");
        if (savedUser && savedToken) {
          setUser(JSON.parse(savedUser));
          setToken(savedToken);
        }
      } finally {
        setLoading(false);
      }
    };

    verify();
  }, []);

  const login = (tokenData, userData) => {
    localStorage.setItem("token",  tokenData);
    localStorage.setItem("user",   JSON.stringify(userData));
    setToken(tokenData);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setToken(null);
    setUser(null);
  };

  const updateUser = (updatedUser) => {
    setUser(updatedUser);
    localStorage.setItem("user", JSON.stringify(updatedUser));
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout, loading, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
